import IntegrationForm from './component'

export default IntegrationForm
